// At a venue that charges recurring bookings after play from a stored card (appconfig.recurringcardafterplay), a card
// added there may be used for that only when the customer ticks this box: an explicit, separate choice next to every
// add-card button, unticked by default. Adding a card for something else (a membership, a subscription) must not
// consent to it by itself. The ticked choice goes to utils/addcard.js start({ recurringConsent: true }); the consent
// can also be given or withdrawn later in the profile's card list. Renders nothing at other venues.
import React from 'react'
import { useTranslation } from 'react-i18next'
import Checkbox from '@material-ui/core/Checkbox'
import withAppconfig from '../AppContext'

function RecurringCardConsentNote({ appconfig, checked, onChange, style }) {
  const { t } = useTranslation()
  if (!appconfig || !appconfig.recurringcardafterplay) return null
  return (
    <div style={{ fontSize: 'small', marginTop: 6, display: 'flex', alignItems: 'flex-start', textAlign: 'left', ...(style || {}) }}>
      <Checkbox
        checked={Boolean(checked)}
        onChange={(e) => onChange && onChange(e.target.checked)}
        color='primary'
        size='small'
        style={{ paddingTop: 0, paddingLeft: 0 }}
        inputProps={{ 'aria-label': t('recurring_card_venue_consent_check') }}
      />
      <span>
        {t('recurring_card_venue_consent_check')} {t('recurring_card_venue_consent_withdraw')}
      </span>
    </div>
  )
}

export default withAppconfig(RecurringCardConsentNote)
